/**
 * Method to get the style of the used car name displayed
 * into the info panel of the used car drawer.
 * @returns {{marginTop: number}} — CSS style.
 */
export const getUsedCarDrawerInfoPanelCarNameStyle = () => {
	return {
		marginTop: "var(--zero-margin)",
	};
};
